import script from "./SelectBrandsStepMultiple.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectBrandsStepMultiple.vue?vue&type=script&setup=true&lang=js"

import "./SelectBrandsStepMultiple.vue?vue&type=style&index=0&id=587e0f51&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-587e0f51"]])

export default __exports__